import { LoggedInUserProfileContext } from "features/auth/AuthRoute";
import { DateTime } from "luxon";
import { useContext } from "react";

export const useUserTimezone = () => {
    const user = useContext(LoggedInUserProfileContext);
    return user?.timeZone || DateTime.local().zoneName;
};
